import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const WhatsAppWebText = styled(Typography)({
  fontFamily: 'Zen Kaku Gothic Antique',
  marginRight: '2px',
  fontSize: '16px',
  color: '#353F48',
})
